import ziperase from '../../services/ziperase';
import { notify } from '../../services/notify';

const state = {
  products: null,
  selectedVersion: null,
  selectedProduct: null,
  selectedDownload: null
}

const mutations = {
  products (state, products) {
    state.products = products;
  },
  selectVersion (state, version) {
    state.selectedVersion = version;
  },
  selectProduct (state, product) {
    state.selectedProduct = product;
  },
  selectDownload (state, download) {
    state.selectedDownload = download;
  }
}

const getters = {
  products: () => state.products,
  selectedVersion: () => state.selectedVersion,
  selectedProduct: () => state.selectedProduct,
  selectedDownload: () => state.selectedDownload,
  productMap: () => {
    let map = {};
    if (!state.products) {
      return map;
    }
    state.products.map(product => {
      map[product.id] = product;
    });
    return map;
  }
}

const actions = {
  async fetchProducts({ commit }) {
    try {
      const response = await ziperase.fetchProducts();
      commit('products', response.data);
    } catch (error) {
      console.log(error);
      notify().error('Failed to retrieve products.');
    }
  },
  async createVersion({}, version) {
    try {
      await ziperase.createVersion(version);
      return true;
    } catch (error) {
      notify().error('Failed to create version.');
      return false;
    }
  },
  async updateVersion({ commit }, version) {
    try {
      const response = await ziperase.updateVersion(version.version_id, version);
      commit('selectedVersion', response.data);
      notify().success(`Success! Updated version ${version.version}.`);
      return true;
    } catch (error) {
      notify().error('Failed to update version.');
      return false;
    }
  },
  async createDownload({}, download) {
    try {
      await ziperase.createDownload(download);
      return true;
    } catch (error) {
      notify().error('Failed to create download.');
      return false;
    }
  },
  async updateDownload({ commit }, download) {
    try {
      const response = await ziperase.updateDownload(download.id, download);
      commit('selectedDownload', response.data);
      notify().success('Success! Updated download.');
      return true;
    } catch (error) {
      notify().error('Failed to update download.');
      return false;
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}